import { useCallback, useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { api } from '../../lib/api';
import { PaymentsTable } from './ScenariosTab';
import { Empty, btn2Cls, cardCls } from './shared';

// The shares computed for each received payment under the version locked on its date. Derived
// figures, recomputed whenever a payment is recorded; nothing here pays anyone.

export default function SharesTab({ detail }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const id = detail.agreement.id;

  const load = useCallback(async () => {
    try { setData(await api.get(`/partner-comp/agreements/${id}/shares`)); setError(''); } catch (e) { setError(e.message); }
  }, [id]);
  useEffect(() => { load(); }, [load]);
  const recompute = async () => {
    setBusy(true);
    try { const r = await api.post(`/partner-comp/agreements/${id}/recompute`, {}); setData(r.shares); setError(''); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  if (error && !data) return <p className="text-sm text-rose-600">{error}</p>;
  if (!data) return <p className="text-sm text-[var(--text-secondary)]">Loading...</p>;
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-sm text-[var(--text-secondary)]">{data.note}</p>
        <button className={`${btn2Cls} ml-auto`} disabled={busy} onClick={recompute}><RefreshCw size={14} /> Recompute now</button>
      </div>
      {error && <p className="text-sm text-rose-600">{error}</p>}
      {data.sync?.last_error && (
        <p className="rounded-lg bg-rose-50 p-2 text-sm text-rose-700 dark:bg-rose-900/20 dark:text-rose-300">The last automatic update failed ({data.sync.last_error}). It is retried every few minutes; the figures below are from the last successful update.</p>
      )}
      {!data.has_locked_version && (
        <div className="rounded-lg border border-[var(--border)] bg-gray-50 p-3 text-sm text-[var(--text-primary)] dark:bg-slate-800">
          <strong>No locked agreement yet.</strong> Payments are listed, but no shares are worked out until every partner agrees to a version and it is locked. A version applies to payments received on or after the day it is locked.
        </div>
      )}
      {data.counts.needs_deal > 0 && (
        <p className="text-sm text-amber-700 dark:text-amber-400">{data.counts.needs_deal} {data.counts.needs_deal === 1 ? 'payment needs' : 'payments need'} a deal: link the invoice's order to a deal in Books, Deal payouts, so its roles and direct costs are known.</p>
      )}
      {data.runs.length ? (
        <div className={cardCls}><PaymentsTable rows={data.runs} partners={detail.partners} open={open} setOpen={setOpen} totals={data.totals} showVersion /></div>
      ) : <Empty>No payments received yet.</Empty>}
    </div>
  );
}
